function gSignIn(googleUser) {
  
  console.log('Logged in as: ' + googleUser.getBasicProfile());
  var id_token = googleUser.getAuthResponse().id_token;
  var params = { 
		  "credential":id_token,
    	  "origin":"google"
   };
  loginAjaxConnection(params, $("form.login"));
}

function onFailure(error) {
	
  console.log(error);
}
function loadGooglePrompt() {
    google.accounts.id.initialize({
    	client_id:g_client_id,
    	context:'signin',
    	auto_select:false,
		cancel_on_tap_outside:false,
		prompt_parent_id:'g_prompt',
	    callback:function(response) {
	    	  
			var params = {
				"origin":"google",
				"credential":response.credential
			}
		      loginAjaxConnection(params);
	      }
    });
    google.accounts.id.prompt(function(notification){
		if(notification.isNotDisplayed()) {
			console.log("Google prompt not displayed for the follow reason: "+notification.getNotDisplayedReason());
		} else if(notification.isSkippedMoment()) {
			console.log("Google prompt skipped for the follow reason: "+notification.getSkippedReason());
		} else if(notification.isDismissedMoment()) {
			console.log("Google prompt dimissed for the follow reason: "+notification.getDismissedReason());
		}
	});
}

function gSignOut(e, href){
	google.accounts.id.disableAutoSelect();
	gapi.auth2.getAuthInstance().signOut();
	window.location.href = href;
}


function googleInit() {
 gapi.load('auth2', function() {
	
       gapi.auth2.init({
		client_id:g_client_id,
        scope: 'profile'
       })
.then(function(){
	
			renderSignInButton();
			loadGooglePrompt();
		});
     });
}

function renderSignInButton() {
	
     gapi.signin2.render('myGoogleButton',{
        'scope': 'profile email',
        'width': 300,
        'height': 40,
        'longtitle': true,
        'theme': 'dark',
        'onsuccess': function(googleUser){
			  gSignIn(googleUser);
		},
        'onfailure': function(error){
		  console.log(error);
		}
    });
}

function signOut(e, href){
	e.preventDefault();
	google.accounts.id.disableAutoSelect();
	gapi.auth2.getAuthInstance().signOut();
	window.location.href = href;
}


$.getScript("https://apis.google.com/js/platform.js?onload=loadGooglePrompt");
$.getScript("https://accounts.google.com/gsi/client");

window.googleInit = googleInit;
